import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  ProductPurchaseMutationVoidInput,
  ProductPurchaseMutationInput,
  ProductPurchaseMutationUpdateInput,
  ProductPurchaseModel,
} from './model';

export function useCreateProductPurchase(
  options?: UseMutationOptions<
    ApiResult<ProductPurchaseModel>,
    ApiError,
    ProductPurchaseMutationInput
  >,
) {
  return useMutation<
    ApiResult<ProductPurchaseModel>,
    ApiError,
    ProductPurchaseMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'product-purchases',
      method: 'POST',
      body,
      classType: ProductPurchaseModel,
    });
  }, options);
}

export function useUpdateProductPurchase(
  options?: UseMutationOptions<
    ApiResult<ProductPurchaseModel>,
    ApiError,
    ProductPurchaseMutationUpdateInput
  >,
) {
  return useMutation<
    ApiResult<ProductPurchaseModel>,
    ApiError,
    ProductPurchaseMutationUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `product-purchases/${body.id}`,
      method: 'PUT',
      body: body.body,
      classType: ProductPurchaseModel,
    });
  }, options);
}

export function useVoidProductPurchase(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    ProductPurchaseMutationVoidInput
  >,
) {
  return useMutation<
    ApiResult<any>,
    ApiError,
    ProductPurchaseMutationVoidInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `product-purchases/${body.id}/void`,
      method: 'PATCH',
    });
  }, options);
}
